import { type NotificationModalInfo } from '@/types/global.types';
import mitt from 'mitt';

type Events = {
  displayinfo: NotificationModalInfo;
  showTooltip: { content: string, event: MouseEvent }; 
  hideTooltip: void;
  [key: string]: any;
};

const eventBus = mitt<Events>();

export default eventBus;